import { Clock } from 'lucide-react';

/**
 * Slim "setup in progress" banner for read-only pages that don't need to
 * be fully blocked (Call Logs, Booked Calls, Analytics, Billing,
 * Communication Usage). Shows at the top of the page when
 * `useDashboardStatus().ready === false` so the client understands why
 * the page is empty without being locked out of the layout.
 *
 * Rendered inline above the page's normal content — the page still works
 * for whatever data does exist; this just adds context.
 */
export default function SetupInProgressBanner() {
    return (
        <div
            className="mb-4 flex items-start gap-3 rounded-lg border border-orange-200 bg-orange-50 px-4 py-3"
            data-testid="setup-in-progress-banner"
        >
            <Clock className="h-5 w-5 flex-shrink-0 text-orange-500 mt-0.5" />
            <div className="flex-1 text-sm">
                <p className="font-medium text-orange-900">Your dashboard is still being set up</p>
                <p className="mt-0.5 text-orange-800">
                    Data will start appearing here once your agency completes the wire-up. You&apos;ll receive a welcome email the moment everything is live.
                </p>
            </div>
        </div>
    );
}
